import { render, staticRenderFns } from "./customInterval.vue?vue&type=template&id=b9979e2e"
import script from "./customInterval.vue?vue&type=script&lang=js"
export * from "./customInterval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports